import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-847ce60c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal-message"
}
const _hoisted_2 = {
  class: "v-card-text",
  style: {"opacity":"1"}
}
const _hoisted_3 = { class: "v-card-actions" }
const _hoisted_4 = { class: "full-overlay" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

import { computed, ref, watch } from 'vue';
import { messages, authError } from '@/utility/messages';
import { axiosConnections } from '@/utility/axios-lib-utilities';
import router from '@/router/index';
// import { adminLogin, tabletLogin, employeeLogin } from '@/router/index';
import { logout } from '@/utility/login';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const emptyFunction = () => {
  // do nothing
};

const message = computed(() => (messages.value.length === 0 ? null : messages.value[0]));

const messageType = computed(() => message.value?.type ?? '');
const isConfirm = computed(() => message.value?.type === 'confirm');
const isYesNo = computed(() => message.value?.type === 'yesno');
const messageLines = computed(() => message.value?.text.split('\n') ?? []);
const resolve = computed(() => message.value?.resolve ?? emptyFunction);
const style = computed(() => message.value?.style);
const buttonStyle = computed(() => message.value?.buttonStyle);

const dialog = ref(false);
watch(
  () => messages.value.length,
  length => {
    if (length > 0 && !dialog.value) {
      dialog.value = true;
    }
  }
);

const dialogHeader = computed(() => {
  const type = messageType.value;
  if (type === 'info') return '情報';
  if (type === 'error') return '警告';
  if (type === 'confirm') return '確認';
  if (type === 'yesno') return '確認';
  if (type === authError) return '認証エラー';
  return '';
});

const okBtnTitle = computed(() => {
  const type = messageType.value;
  if (type === 'info' || type === 'error' || type === 'confirm') return 'OK';
  if (type === 'yesno') return 'はい';
  if (type === authError) return 'ログアウト';
  return '';
});

const okCancelTitle = computed(() => {
  const type = messageType.value;
  if (type === 'info' || type === 'error' || type === authError) return 'OK';
  if (type === 'confirm') return 'キャンセル';
  if (type === 'yesno') return 'いいえ';
  return '';
});

let fromMessageNext = false;
watch(dialog, async opened => {
  if (opened || fromMessageNext) return;
  dialog.value = true;
  dialogCancel();
});

function messageNext() {
  fromMessageNext = true;
  dialog.value = false;
  setTimeout(() => {
    fromMessageNext = false;
    messages.value.shift();
    if (messages.value.length > 0) {
      dialog.value = true;
    }
  }, 300);
}

function dialogCancel() {
  resolve.value(false);
  messageNext();
}

function dialogOk() {
  if (messageType.value === authError) {
    messages.value.length = 0;

    // const path = router.currentRoute.value.path;
    // const nextName = ref('');
    /*    if (path.indexOf('/admin/') >= 0) nextName.value = adminLogin;
    else if (path.indexOf('/tablet/') >= 0) nextName.value = tabletLogin;
    else if (path.indexOf('/employee/') >= 0) nextName.value = employeeLogin;*/
    logout();
    router.push({ name: '' });
  }

  resolve.value(true);
  messageNext();
}

const isSpinning = computed(() => axiosConnections.value > 0);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    (dialog.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            style: _normalizeStyle(_unref(style))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["v-card-title", ['modal-title', _unref(messageType)]])
            }, _toDisplayString(_unref(dialogHeader)), 3),
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(messageLines), (line, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "line"
                }, _toDisplayString(line), 1))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                class: "btn-small ok",
                text: "",
                variant: "outlined",
                onClick: dialogOk,
                style: _normalizeStyle(_unref(buttonStyle))
              }, _toDisplayString(_unref(okBtnTitle)), 5),
              (_unref(isConfirm) || _unref(isYesNo))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn-small",
                    text: "",
                    variant: "outlined",
                    onClick: dialogCancel,
                    style: _normalizeStyle(_unref(buttonStyle))
                  }, _toDisplayString(_unref(okCancelTitle)), 5))
                : _createCommentVNode("", true)
            ])
          ], 4)
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _withDirectives(_createElementVNode("div", _hoisted_4, _hoisted_6, 512), [
        [_vShow, _unref(isSpinning)]
      ])
    ]))
  ], 64))
}
}

})